import React from "react";

const SIGNAL_META = {
  weather_event:        { icon: "🌧️", label: "Weather event" },
  traffic_density:      { icon: "🚦", label: "Traffic density" },
  latency_anomaly:      { icon: "📡", label: "Latency anomaly" },
  infrastructure_defect:{ icon: "🛣️", label: "Infrastructure defect" },
};

const CONFIDENCE_CLS = {
  high:   "border-green-200 bg-green-50 text-green-700 dark:border-green-700 dark:bg-green-900/20 dark:text-green-400",
  medium: "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-400",
  low:    "border-gray-200 bg-gray-100 text-gray-500 dark:border-white/10 dark:bg-white/5 dark:text-gray-400",
};

const WhySection = ({ signals }) => (
  <section className="border-b border-gray-100 p-4 dark:border-white/5">
    <p className="mb-3 text-[10px] font-bold uppercase tracking-widest text-gray-400">Why</p>
    <ul className="space-y-2">
      {signals.map((sig, i) => {
        const meta = SIGNAL_META[sig.type] ?? { icon: "•", label: sig.type };
        return (
          <li
            key={i}
            className="flex items-start gap-2.5 rounded-lg border border-gray-100 bg-gray-50 px-3 py-2 dark:border-white/5 dark:bg-navy-900/40"
          >
            <span className="mt-px shrink-0 text-sm" aria-hidden="true">
              {meta.icon}
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-[9px] font-bold uppercase tracking-wide text-gray-400">
                {meta.label}
              </p>
              <p
                className={`text-xs font-medium leading-snug ${
                  sig.source_available
                    ? "text-gray-700 dark:text-gray-300"
                    : "italic text-gray-400 dark:text-gray-500"
                }`}
              >
                {sig.source_available ? sig.value : "Source unavailable"}
              </p>
            </div>
            <span
              className={`mt-0.5 shrink-0 rounded border px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide ${
                CONFIDENCE_CLS[sig.confidence] ?? CONFIDENCE_CLS.low
              }`}
            >
              {sig.confidence}
            </span>
          </li>
        );
      })}
    </ul>
  </section>
);

export default WhySection;
